/**
 * Convert a RACQ membership number into an EAN13 payload according to spec.
 *
 * Spec (as implemented previously):
 * - Remove spaces
 * - Take digits 7–15 (0-indexed substring 6..15) as core
 * - Prefix with "260"
 * - Compute check digit: reverse-iterate, sum odds *3 + evens, (1000 - sum) % 10
 */
export function makeEan13FromMembership(raw: string): string | null {
  if (!raw) return null;
  const sanitized = raw.replace(/\s+/g, '').trim();
  if (sanitized.length < 15) return null;

  const coreDigits = sanitized.substring(6, 15);
  const base = '260' + coreDigits;
  const digits = base.split('').map(Number);

  let sum = 0;
  for (let i = digits.length - 1; i >= 0; i -= 2) sum += digits[i];
  sum *= 3;
  for (let i = digits.length - 2; i >= 0; i -= 2) sum += digits[i];

  const checkDigit = (1000 - sum) % 10;
  return base + checkDigit;
}
